import { render } from "./ConvertFormats.vue?vue&type=template&id=c4b2c51c"
const script = {}

import "./ConvertFormats.vue?vue&type=style&index=0&id=c4b2c51c&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__